import Vue from 'vue'
import Router from 'vue-router'
import Home from '@/components/views/home/Home'
import MainLayout from '@/components/layouts/Main'

const Objeto = () => import('@/components/views/objeto/Objeto')
const MinhaConta = () => import('@/components/views/minhaConta/MinhaConta')

const Colecoes = () => import('@/components/views/colecoes/Colecoes')
const MinhasColecoes = () => import('@/components/views/colecoes/MinhasColecoes')
const MeusFavoritos = () => import('@/components/views/colecoes/MeusFavoritos')
const VisualizarColecao = () => import('@/components/views/colecoes/VisualizarColecao')

const Demandas = () => import('@/components/views/demandas/Demandas')

const FaleConosco = () => import('@/components/views/faleConosco/FaleConosco')

const PageNotFound = () => import('@/components/views/pageNotFound/PageNotFound')

const AuthLayout = () => import(/* webpackChunkName: "auth" */'@/components/views/auth/index')
const Login = () => import(/* webpackChunkName: "auth" */'@/components/views/auth/login')
const ForgotPassword = () => import(/* webpackChunkName: "auth" */'@/components/views/auth/forgotPassword')
const RecoverPassword = () => import(/* webpackChunkName: "auth" */'@/components/views/auth/recoverPassword')

const Resultado = () => import('@/components/views/resultado/Resultado')
const ResultadoObjeto = () => import('@/components/views/resultado/objeto/Objeto')
const ResultadoColecao = () => import('@/components/views/resultado/colecao/Colecao')

const loggedRoutes = [
	{
		path: '/objeto/:id',
		meta: { auth: [1, 4], redirect: { name: 'login' } },
		name: 'objeto',
		component: Objeto
	},
	{
		path: '/resultado',
		meta: { auth: [1, 4], redirect: { name: 'login' } },
		component: Resultado,
		children: [
			{
				path: 'objeto',
				meta: { auth: [1, 4], redirect: { name: 'login' } },
				name: 'resultadoObjeto',
				component: ResultadoObjeto
			},
			{
				path: 'colecao',
				meta: { auth: [1, 4], redirect: { name: 'login' } },
				name: 'resultadoColecao',
				component: ResultadoColecao
			}
		]
	},
	{
		path: '/minhaconta',
		meta: { auth: [1, 4], redirect: { name: 'login' } },
		name: 'minhaConta',
		component: MinhaConta
	},
	{
		path: '/colecoes',
		meta: { auth: [1, 4], redirect: { name: 'login' } },
		component: Colecoes,

		children: [
			{
				path: 'minhasColecoes',
				meta: { auth: [1, 4], redirect: { name: 'login' } },
				name: 'minhasColecoes',
				component: MinhasColecoes
			},
			{
				path: 'meusFavoritos',
				meta: { auth: [1, 4], redirect: { name: 'login' } },
				name: 'meusFavoritos',
				component: MeusFavoritos
			}
		]
	},
	{
		path: 'visualizarColecao',
		meta: { auth: [1, 4], redirect: { name: 'login' } },
		name: 'visualizarColecao',
		component: VisualizarColecao
	},
	{
		path: '/demandas',
		meta: { auth: [1, 4], redirect: { name: 'login' } },
		name: 'demandas',
		component: Demandas
	}
]

const routes = [
	{
		path: '/',
		meta: { auth: [1, 4], redirect: { name: 'login' } },
		name: 'home',
		component: Home
	},
	{
		path: '/',
		component: MainLayout,
		children: loggedRoutes
	},
	{
		path: '/login',
		component: AuthLayout,
		children: [
			{ path: '', name: 'login', component: Login },
			{ path: 'forgot-password', name: 'forgotPassword', component: ForgotPassword },
			{ path: 'recover-password/:id', name: 'recoverPassword', component: RecoverPassword }
		]
	},
	{ path: '/faleconosco', name: 'faleConosco', component: FaleConosco },
	{ path: '*', component: PageNotFound }
]

Vue.use(Router)

export default new Router({
	routes,
	scrollBehavior (to, from, savedPosition) {
		// Desativa a rolagem ao topo na página de resultados
		const skipScrolling = ['resultadoObjeto'] // Nome das rotas que não sofrerão com a rolagem ao topo
		if (skipScrolling.indexOf(to.name) > -1) return

		if (savedPosition) return savedPosition
		else return { x: 0, y: 0 }
	},
	linkActiveClass: 'active',
	linkExactActiveClass: 'exact-active',
	mode: 'history'
})
